"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var vizColorValueOrder = exports.vizColorValueOrder = {
  300: [300, 700, 400, 800, 200, 600, 100, 500, 900],
  400: [400, 600, 300, 800, 100, 700, 200, 500, 900],
  500: [500, 100, 800, 200, 700, 300, 600, 900, 400],
  600: [600, 200, 800, 300, 700, 100, 400, 900, 500]
};
var vizColorHueOrder = exports.vizColorHueOrder = ["opengov", "periwinkle", "orange", "yellow", "violet", "purple", "teal", "jade", "royal", "indigo", "ruby", "port", "cerulean", "turquoise", "red", "terracotta", "sage", "pear", "magenta", "rose"];
var vizColor_hoverOpacity = exports.vizColor_hoverOpacity = 0.25;
var vizColor_hoverfilter = exports.vizColor_hoverfilter = "grayscale(80%)";
var vizColors = exports.vizColors = {
  pear: {
    50: "#EBFFEE",
    100: "#D7FADD",
    200: "#B9EBC2",
    300: "#9AD9A4",
    400: "#77C785",
    500: "#53B062",
    600: "#3C964B",
    700: "#257D34",
    800: "#1A5924",
    900: "#083B11",
    1000: "#012608",
    data: 300,
    highlight: 50,
    nextHue: "magenta"
  },
  sage: {
    50: "#EDFAF2",
    100: "#DDF0E4",
    200: "#C3E3D0",
    300: "#A3D1B5",
    400: "#88C29F",
    500: "#74B28D",
    600: "#549970",
    700: "#3E7D57",
    800: "#2E5C40",
    900: "#20402D",
    1000: "#172E20",
    data: 600,
    highlight: 50,
    nextHue: "rose"
  },
  jade: {
    50: "#EBFCF7",
    100: "#CBF5E8",
    200: "#ADE0D0",
    300: "#7CCFB4",
    400: "#56BA9A",
    500: "#2FA882",
    600: "#1E8F6B",
    700: "#147556",
    800: "#0C573F",
    900: "#033827",
    1000: "#002418",
    data: 300,
    highlight: 50,
    nextHue: "ruby"
  },
  teal: {
    50: "#EBF7F6",
    100: "#D3F0ED",
    200: "#B8E0DC",
    300: "#9BD1CC",
    400: "#79C9C1",
    500: "#57B5AC",
    600: "#3D9990",
    700: "#2E8077",
    800: "#21665E",
    900: "#13453F",
    1000: "#0A2925",
    data: 600,
    highlight: 50,
    nextHue: "jade"
  },
  turquoise: {
    50: "#EBFCFC",
    100: "#CEF3F5",
    200: "#AEE4E5",
    300: "#8BD4D6",
    400: "#6DBFC2",
    500: "#45AAAD",
    600: "#299094",
    700: "#1D7578",
    800: "#0F595C",
    900: "#033B3D",
    1000: "#002021",
    data: 300,
    highlight: 50,
    nextHue: "red"
  },
  cerulean: {
    50: "#E8F5FA",
    100: "#D0EAF5",
    200: "#B1D7E5",
    300: "#97CADE",
    400: "#7CBED9",
    500: "#5FABC9",
    600: "#4692B0",
    700: "#367791",
    800: "#275D73",
    900: "#164152",
    1000: "#0B242E",
    data: 600,
    highlight: 50,
    nextHue: "terracotta"
  },
  opengov: {
    50: "#F0F7FF",
    100: "#D9EBFF",
    200: "#B4D6FA",
    300: "#91C0F2",
    400: "#75AEEB",
    500: "#5B98D9",
    600: "#4781BF",
    700: "#2E6299",
    800: "#1D4673",
    900: "#0F2D4D",
    1000: "#001933",
    data: 600,
    highlight: 50,
    nextHue: "yellow"
  },
  periwinkle: {
    50: "#EBF0F7",
    100: "#D8E1F0",
    200: "#BED0ED",
    300: "#A1BBE5",
    400: "#82A3D9",
    500: "#6A92D4",
    600: "#5079BA",
    700: "#3D6099",
    800: "#2E4873",
    900: "#1D3254",
    1000: "#0C1E3B",
    data: 300,
    highlight: 50,
    nextHue: "orange"
  },
  royal: {
    50: "#EDF0FF",
    100: "#E0E6FF",
    200: "#BDC9FF",
    300: "#9DADF5",
    400: "#7D90E3",
    500: "#6579CF",
    600: "#4C5FB5",
    700: "#324494",
    800: "#1C2A6B",
    900: "#0D1A52",
    1000: "#040D36",
    data: 600,
    highlight: 50,
    nextHue: "port"
  },
  indigo: {
    50: "#EDEEFA",
    100: "#E1E2F5",
    200: "#CCCEF0",
    300: "#B1B4DE",
    400: "#979ACC",
    500: "#797CB8",
    600: "#5C5F99",
    700: "#484B85",
    800: "#3A3C6B",
    900: "#292B4C",
    1000: "#10112E",
    data: 400,
    highlight: 50,
    nextHue: "ruby"
  },
  violet: {
    50: "#EFEBFF",
    100: "#E6DEFF",
    200: "#D4C8FA",
    300: "#C0B1F2",
    400: "#A492E0",
    500: "#8D7ACC",
    600: "#6F5DA8",
    700: "#54438A",
    800: "#3E2E73",
    900: "#241554",
    1000: "#110538",
    data: 600,
    highlight: 50,
    nextHue: "jade"
  },
  purple: {
    50: "#F5EBFA",
    100: "#ECD7F5",
    200: "#E5C7F2",
    300: "#CDABDB",
    400: "#B38FC2",
    500: "#A07BB0",
    600: "#885F99",
    700: "#6B477A",
    800: "#543461",
    900: "#3B2445",
    1000: "#231429",
    data: 300,
    highlight: 50,
    nextHue: "teal"
  },
  magenta: {
    50: "#FFE5F4",
    100: "#FFCCE9",
    200: "#F2B6D8",
    300: "#E096C0",
    400: "#C476A2",
    500: "#B55E8F",
    600: "#9C4174",
    700: "#802458",
    800: "#630F3F",
    900: "#47062B",
    1000: "#2E001A",
    data: 600,
    highlight: 50,
    nextHue: "periwinkle"
  },
  rose: {
    50: "#FAEBEF",
    100: "#FAD4DE",
    200: "#EDBECA",
    300: "#E09DAF",
    400: "#CF7C92",
    500: "#BD5E78",
    600: "#9E465D",
    700: "#7D3347",
    800: "#632938",
    900: "#4A1E2A",
    1000: "#30141B",
    data: 400,
    highlight: 50,
    nextHue: "opengov"
  },
  ruby: {
    50: "#FFE5E8",
    100: "#FFD4D9",
    200: "#FABBC2",
    300: "#ED9AA2",
    400: "#DE7882",
    500: "#CC5E69",
    600: "#B24954",
    700: "#992F3A",
    800: "#801B25",
    900: "#660B14",
    1000: "#4C0108",
    data: 500,
    highlight: 50,
    nextHue: "turquoise"
  },
  port: {
    50: "#FFEBEB",
    100: "#FFD5D4",
    200: "#FABBB9",
    300: "#EDA19F",
    400: "#D98784",
    500: "#C76E6B",
    600: "#B85854",
    700: "#994946",
    800: "#783937",
    900: "#5C2C2A",
    1000: "#401E1D",
    data: 300,
    highlight: 50,
    nextHue: "cerulean"
  },
  red: {
    50: "#FFECE8",
    100: "#FFDAD1",
    200: "#FABDAF",
    300: "#F59D89",
    400: "#E87E66",
    500: "#E0694F",
    600: "#D15336",
    700: "#B23E24",
    800: "#942A12",
    900: "#6B1C0B",
    1000: "#4C0E00",
    data: 500,
    highlight: 50,
    nextHue: "pear"
  },
  terracotta: {
    50: "#FFEDE5",
    100: "#FFDBCC",
    200: "#FAC4AC",
    300: "#F5A482",
    400: "#ED8A5F",
    500: "#E07446",
    600: "#D16B3F",
    700: "#B85830",
    800: "#9C441F",
    900: "#802F0D",
    1000: "#662408",
    data: 300,
    highlight: 50,
    nextHue: "sage"
  },
  orange: {
    50: "#FFEEDB",
    100: "#FFE0BD",
    200: "#FFCF99",
    300: "#FABD78",
    400: "#F0AB5D",
    500: "#E59539",
    600: "#DB831F",
    700: "#C77110",
    800: "#B06209",
    900: "#995303",
    1000: "#703C00",
    data: 500,
    highlight: 50,
    nextHue: "purple"
  },
  yellow: {
    50: "#FFFAED",
    100: "#FFF3D4",
    200: "#FCE9B8",
    300: "#F0DBA8",
    400: "#E8CE8B",
    500: "#E3C476",
    600: "#D9B55B",
    700: "#BF9E49",
    800: "#B29240",
    900: "#8F773B",
    1000: "#756233",
    data: 400,
    highlight: 50,
    nextHue: "violet"
  }
};